<template>
  <section class="mb-6 card" :aria-label="t('Reviews.profileCompletion.title')">
    <div class="flex items-start justify-between gap-3">
      <div>
        <div class="flex items-center gap-2">
          <p class="text-headline-s">{{ t('Reviews.profileCompletion.title') }}</p>
          <ChipBadge v-if="isComplete" color="purple" rounded size="s" :prepend-icon="mdiCheck">
            {{ t('Reviews.profileCompletion.complete') }}
          </ChipBadge>
        </div>
        <p class="mt-0.5 text-body-s text-subtlest">{{ t('Reviews.profileCompletion.helper') }}</p>
      </div>
      <span class="shrink-0 text-headline-m" :class="isComplete ? 'text-primary-strong' : ''">{{ result.total }}%</span>
    </div>

    <LinearProgress class="mt-4" percentage="none" :progress="result.total" :aria-label="t('Reviews.profileCompletion.title')" />

    <div class="mt-6 flex flex-wrap justify-around gap-4">
      <ProfileCompletionRing
        v-for="section in result.sections"
        :key="section.id"
        :percentage="section.percentage"
        :label="t(section.labelKey)"
        :to="editRouteFor(section.editRouteName)"
      />
    </div>
  </section>
</template>

<script setup lang="ts">
import { mdiCheck } from '@mdi/js'
import { ChipBadge, LinearProgress } from '@ramp106/omrjs-core-ui'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import type { RouteLocationRaw } from 'vue-router'

import type { CompletionResult } from './completionTypes'
import ProfileCompletionRing from './ProfileCompletionRing.vue'

const props = defineProps<{
  result: CompletionResult
  entityId: string
  idParam: 'productId' | 'agencyId'
}>()

const { t } = useI18n()

const isComplete = computed(() => props.result.total === 100)

const editRouteFor = (name: string): RouteLocationRaw => ({
  name,
  params: { [props.idParam]: props.entityId },
})
</script>
